import React, { useState } from 'react';
import { trackEvent } from '../utils/analytics';
import './NewsletterSignup.css';

const NewsletterSignup = ({ source = 'footer' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      const res = await fetch('/api/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source }),
      });
      if (res.ok) {
        trackEvent('newsletter_signup', { source });
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="newsletter-signup">
      <h4>Newsletter</h4>
      <p>Subscribe for deals and updates</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" data-track="button_click" data-track-label="newsletter_submit">Subscribe</button>
      </form>
      {status === 'success' && <p className="newsletter-msg success">Subscribed!</p>}
      {status === 'error' && <p className="newsletter-msg error">Please try again.</p>}
    </div>
  );
};

export default NewsletterSignup;
